import { CookiesPolicyAgreementCard } from '@sravni/react-cookies-policy';
import { useIsMobile } from '@sravni/react-utils';

import { useAppSelector } from 'shared/lib';

import {
  selectIsFullDealPage,
  selectIsLoansLandingPage,
  selectIsMarketplaceEnabled,
  selectIsMarketplaceSeoPage,
  selectIsVitrinsPage,
} from 'entities/siteSettings';
import { isWLFullLandingSelector, isWLSelector } from 'entities/whiteLabels';

import { MainPageFooter } from 'widgets/Footer';
import { MainSiteHeader } from 'widgets/Header';

/** Отвечает за показ хедера и футера */
export const PageWrapper: FC = ({ children }) => {
  const isMobile = useIsMobile();

  const isWl = useAppSelector(isWLSelector);
  const isFullLanding = useAppSelector(isWLFullLandingSelector);
  const isFullDealPage = useAppSelector(selectIsFullDealPage);
  const isVitrinsPage = useAppSelector(selectIsVitrinsPage);
  const isLoansLandingPage = useAppSelector(selectIsLoansLandingPage);
  const isMarketplaceSeoPage = useAppSelector(selectIsMarketplaceSeoPage);
  const isShowHeader = isFullLanding || !isWl;
  const isShowFooter = isFullLanding || !(isWl || isFullDealPage);
  const isEnableCookiePolicy = !isWl;
  const isMarketplaceEnabled = useAppSelector(selectIsMarketplaceEnabled);

  const isVitrinsHeader = isVitrinsPage || isMarketplaceSeoPage;

  return (
    <>
      {isShowHeader && <MainSiteHeader fixedBackground={isVitrinsHeader} />}

      {children}

      {isShowFooter && <MainPageFooter variant={isLoansLandingPage ? 'secondary' : 'primary'} />}

      {isEnableCookiePolicy && (
        <CookiesPolicyAgreementCard
          companyName={isMarketplaceEnabled ? 'mpl' : 'sravni'}
          placement={isMobile ? 'top' : 'bottom-start'}
        />
      )}
    </>
  );
};
